import { Card, CardContent, CardHeader, Input, Stack } from "@mui/material";
import { areaColors } from "../Bcs/BasicCard";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import DropWrapper from "./DropWrapper";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  editGroupName,
  selectGroupById,
  selectMembers,
} from "../../features/daoTrang/daoTrangSlice";
import { SubGroupCard } from "./SubGroupCard";

export function GroupCard(colorIndex, { id }) {
  const group = useAppSelector((state) => selectGroupById(state, id));
  console.log("GroupCard", group);
  const { name } = group;
  const dispatch = useAppDispatch();
  const users = useAppSelector(selectMembers);
  const candidates = !users
    ? []
    : users.filter((u) => {
        for (var sub of group.subGroups) {
          if (sub.members.includes(users.email)) return false;
        }
        // if (group.leader === u.email) return false;
        // if (group.subLeader.includes(u.email)) return false;
        // if (group.members.includes(u.email)) return false;
        // if (group.name.match(/BLĐ|BTS|BQC|BTT|BTC|BNL|LHL/)) {
        //   if (u.thanhPhan !== "A") return false;
        // }
        return true;
      });
      console.log({users, candidates})
  function changeGroupName(v) {
    console.log(v);
    dispatch(editGroupName({ name: v, id: group.id }));
  }
  return (
    <Card
      style={{ backgroundColor: areaColors[colorIndex % areaColors.length] }}
    >
      <CardHeader
        title={
          <Input
            value={name}
            onChange={(e) => changeGroupName(e.target.value)}
          />
        }
      />
      <CardContent>
        <DndProvider backend={HTML5Backend}>
          <Stack spacing={1} direction={"column"}>
            {group.subGroups.map((sub, i) => {
              var c = {
                group,
                name: sub.name,
                members: sub.members ? sub.members : [],
                lst: candidates,
              };
              return (
                <DropWrapper key={i} container={c}>
                  <SubGroupCard container={c} />
                </DropWrapper>
              );
            })}
          </Stack>
        </DndProvider>
      </CardContent>
    </Card>
  );
}
